<template>
  <header
    class="site-header"
    :class="[{ 'open' : isOpen }, style_color, { 'home' : home }]"
    id="site-header"
  >

      <a href="/" class="logo">
        <img
          v-if="style_color === 'light' || isOpen"
          src="/images/logo-light.png" alt="St Lukes Logo"
        />
        <img
          v-else
          src="/images/logo-dark.png" alt="St Lukes Logo"
        />
      </a>

      <nav @mouseleave="isOpen = false">
        <ul class="top">
          <li
            v-for="(link, index) of menu"
            :key="index"
          >
            <a :href="link.url">{{ link.title }}</a>
          </li>
          <li v-if="logged_in">
            <app-logout-link :csrf="csrf"></app-logout-link>
          </li>
        </ul>

        <button
          class="hamburger closed desktop"
          @click="isOpen = false"
        >
          <span></span><span></span><span></span>
        </button>
      </nav>

      <button
        class="hamburger "
        @click="toggleMenu"
        @mouseover="toggleMenuHover"
      >
        <span></span><span></span><span></span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  props: [
    'csrf', 'menu', 'logged_in', 'style_color', 'home'
  ],

  data () {
    return {
      isOpen: false,
    };
  },

  methods: {
    
    toggleMenu () {
      if (this.checkIfMobile() === true) {
        this.isOpen = !this.isOpen
      } else {
        // this.isOpen = false
      }
    },

    toggleMenuHover () {
      if (this.checkIfMobile() === false) {
        this.isOpen = true
      }
    },

    checkIfMobile () {
      if (window.innerWidth > 1024) {
        return false
      } else {
        return true
      }
    }

  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue